// extracted by mini-css-extract-plugin
export var attribution = "_co-4";
export var authorName = "_co-5";
export var quote = "_co-3";
export var testimonial = "_co-2";
export var trustedBy = "_co-0";
export var trustedByLabel = "_co-1";